import logSentryError from 'utils/logSentry';

import * as APIClient from './APIClient';

export const post = segmentName =>
  APIClient.post('/v1/tag_segment', { segment_name: segmentName }).catch(error =>
    logSentryError(`[Tag segment service] post ${segmentName}`, error)
  );
